import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'
import store from './store/index'
import isBlocked from './util/isBlocked.js'

// import scrollBehavior from './scrollBehavior.js'
const Home = () => import(/* webpackChunkName: "home" */ './views/Home.vue')
const Project = () => import(/* webpackChunkName: "project" */ './views/Project.vue')
const About = () => import(/* webpackChunkName: "about" */ './views/About.vue')
const Event = () => import(/* webpackChunkName: "event" */ './views/Event.vue')
const eventsIndex = () => import(/* webpackChunkName: "eventsIndex" */ './views/eventsIndex.vue')
const projectIndex = () => import(/* webpackChunkName: "projectIndex" */ './views/ProjectIndex.vue')
const covidResources = () => import('./views/CovidResources.vue')

const authPage = () => import(/* webpackChunkName: "authPage" */ './views/Auth.vue')

const legalIndex = () => import(/* webpackChunkName: "legalIndex" */ './views/legal/legalIndex.vue')
const termsOfService = () => import(/* webpackChunkName: "termsOfService" */ './views/legal/termsOfService.vue')
const privacyAndSecurity = () => import(/* webpackChunkName: "privacyAndSecurity" */ './views/legal/privacyAndSecurity.vue')

const adminDashboard = () => import(/* webpackChunkName: "adminDashboard" */ './views/admin/adminDashboard.vue')
const createProject = () => import(/* webpackChunkName: "createProject" */ './views/admin/createProject.vue')
const createContributor = () => import(/* webpackChunkName: "createContributor" */ './views/admin/createContributor.vue')
const eventIndex = () => import(/* webpackChunkName: "eventIndex" */ './views/admin/eventIndex.vue')
const createEvent = () => import(/* webpackChunkName: "createEvent" */ './views/admin/createEvent.vue')
const portfolio = () => import(/* webpackChunkName: "portfolio" */ './views/admin/portfolio.vue')
const notFound404 = () => import(/* webpackChunkName: "notFound404" */ './views/notFound404.vue')

Vue.use(Meta)
Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      // savedPosition is only available for popstate navigations.
      return savedPosition
    }
    if (to.hash) {
      return { selector: to.hash }
    }
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve({ x: 0, y: 0 })
      }, 500)
    })
  },
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/about',
      name: 'About',
      component: About
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      // component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    },
    {
      path: '/covid',
      name: 'Covid',
      component: covidResources
    },
    {
      path: '/project/',
      name: 'Experiments',
      alias: '/experiments/',
      component: projectIndex
    },
    {
      path: '/project/:id',
      name: 'Project',
      component: Project
    },
    {
      path: '/event/:id',
      name: 'Event',
      component: Event
    },
    {
      path: '/event',
      alias: '/community',
      name: 'Community Event Calendar',
      component: eventsIndex
    },
    {
      path: '/legal',
      name: 'Legal',
      component: legalIndex
    },
    {
      path: '/legal/terms-of-service',
      name: 'Terms Of Service',
      alias: '/legal/tos',
      component: termsOfService
    },
    {
      path: '/legal/privacy-and-security',
      name: 'Privacy And Security',
      alias: '/legal/pas',
      component: privacyAndSecurity
    },
    {
      path: '/login',
      alias: '/auth',
      name: 'authPage',
      component: authPage
    },
    {
      path: '/admin',
      name: 'adminIndex',
      component: adminDashboard
    },
    {
      path: '/admin/createproject/:id',
      component: createProject
    },
    {
      path: '/admin/event',
      component: eventIndex
    },
    {
      path: '/admin/createEvent/',
      component: createEvent
    },
    {
      path: '/admin/createEvent/:id',
      component: createEvent
    },
    {
      path: '/admin/createproject',
      name: 'createProject',
      component: createProject
    },
    {
      path: '/admin/portfolio',
      name: 'portfolio',
      component: portfolio
    },
    {
      path: '/admin/createContributor/:id',
      name: 'createContributor',
      component: createContributor
    },
    {
      path: '/admin/createContributor',
      component: createContributor
    // }, // 404: empty wallet, transaction error
    // {
    //   path: '/404',
    //   alias: '*',
    //   name: 'notFound404',
    //   component: notFound404
    }

  ]
})

router.beforeEach(async (to, from, next) => {
  let blockedClient = null
  blockedClient = await isBlocked()
  const dest = getNext(to, blockedClient)
  dest.length < 0
    ? next(dest)
    : next()
})

function getNext (to:any, blockedClient) {
  if (
    (
      to.fullPath.includes('/admin') &&
      store.state.isAuth === false
    )
  ) {
    return '/404'
  } else if (
    (
      !to.fullPath.includes('/about') ||
      !to.fullPath.includes('/login') ||
      !to.fullPath.includes('/legal') ||
      !to.fullPath.includes('/community') ||
      !to.fullPath.includes('/event')
    ) &&
    store.state.isAuth === false &&
    blockedClient === true
  ) {
    return '/about'
  } else {
    return ''
  }
}

export { router as default }
